import React from 'react'

import Button from 'components/_new/Button/Button'
import messages from 'components/buttons/CommonButton/messages'


const CommonButton = ({ titleKey, ...rest }) => (
  <Button
    dataTestId={`${titleKey}Button`}
    {...rest}
    title={messages[titleKey]}
  />
)


export default CommonButton
